import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenExpiryService {

  private notifications = new Subject<string>();

  constructor() { }

  getNotifications() {
    return this.notifications.asObservable();
  }

  addNotification(message: string) {
    this.notifications.next(message);
  }
}
